import axios from "axios"
import { useState, useCallback, useEffect, useRef } from "react"
import { LocalStorage } from "storage/localStorage"

export const useAxiosLoader = () => {
  const _isMounted = useRef(true)
  useEffect(() => {
    return () => {
      _isMounted.current = false
    }
  }, [])

  const [counter, setCounter] = useState(0)
  const incrementCounter = useCallback(
    () => setCounter(counter => counter + 1),
    [setCounter]
  ) // add to counter
  const decrementCounter = useCallback(
    () => setCounter(counter => counter - 1),
    [setCounter]
  ) // remove from counter

  // add request interceptors
  const reqInterceptor = axios.interceptors.request.use(
    function (config) {
      if (
        LocalStorage().retrieve("edocAuthId") &&
        LocalStorage().retrieve("edocDeviceId") &&
        LocalStorage().retrieve("edocUserId")
      ) {
        config.headers["Authorization"] =
          "Bearer " + LocalStorage().retrieve("edocAuthId")
        config.headers["X-FourKitesDeviceId"] = LocalStorage().retrieve(
          "edocDeviceId"
        )
        config.headers["X-FourKitesUserId"] = LocalStorage().retrieve(
          "edocUserId"
        )
        config.headers["X-FourKitesAppType"] = "driver-experience"
      }
      if (_isMounted.current) {
        incrementCounter()
      }
      return config
    },
    function (error) {
      if (_isMounted.current) {
        incrementCounter()
      }
      return Promise.reject(error)
    }
  )

  // add response interceptors
  const respInterceptor = axios.interceptors.response.use(
    function (response: any) {
      if (_isMounted.current) {
        decrementCounter()
      }
      return response
    },
    function (error) {
      if (_isMounted.current) {
        decrementCounter()
      }
      return Promise.reject(error)
    }
  )

  useEffect(() => {
    return () => {
      // remove all intercepts when done
      axios.interceptors.request.eject(reqInterceptor)
      axios.interceptors.response.eject(respInterceptor)
    }
  }, [reqInterceptor, respInterceptor])

  return [counter > 0]
}

export const http = {
  post: async (path: string, body: any, headers: any) =>
    axios.post(`${path}`, body, {
      headers: headers
    }),
  put: (path: string, body: any, headers: any) =>
    axios.put(`${path}`, body, {
      headers: headers
    }),
  get: async (url: string, params?: Object) =>
    axios.get(`${url}`, {
      params: params
    })
}
